import './parts/header-backup.js';
import './parts/header.js';
import './parts/mega-menu.js';
import './parts/search.js';
import './parts/footer-responsive.js';
import './parts/home-parallax.js';
import './parts/pull-sidebar.js';
import './parts/toggle-details.js';
import './parts/product-collection-slider.js';
import './parts/term-description.js';
import './parts/size-selector-sidebar.js';
// import "./parts/price-same-line.js";
// import './parts/font-change.js';
import './parts/shop-the-look.js';
import './parts/pandora-quick-swatch.js';
import './parts/cart-checkout-manager.js';
import './parts/pandora-product-video.js';
import './parts/product-recommendations.js';
import './parts/pandora-modle.js';
import './parts/my-account.js';
import './parts/validation.js';
import './parts/mobile-sticky-cart-button.js';

jQuery(function ($) {

	function updateCouponHeight() {
		jQuery('.woocommerce-checkout .wt_coupon_wrapper').each(function() {
			var self = jQuery(this);
			var selfParent = self.closest('.wp-site-blocks');
			var selfHeight = self.outerHeight(true);
			selfParent.find('.myuser-wrapper').css('--coupon-height', selfHeight + 'px');
		});
	}

	updateCouponHeight();
	jQuery(window).on('resize', updateCouponHeight);

	const isIOS =
		/iPad|iPhone|iPod/.test(navigator.userAgent) ||
		(navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

	if (isIOS) {

		/* 1️⃣ Force reset zoom if page is already zoomed */
		function resetZoom() {
			if (window.visualViewport && window.visualViewport.scale > 1) {
				let meta = document.querySelector('meta[name="viewport"]');

				if (!meta) {
					meta = document.createElement('meta');
					meta.name = 'viewport';
					document.head.appendChild(meta);
				}

				// Temporarily allow zoom reset
				meta.setAttribute(
					'content',
					'width=device-width, initial-scale=1, user-scalable=yes'
				);

				// Force repaint so iOS applies it
				document.body.style.zoom = '1';

				// Lock zoom after reset
				setTimeout(() => {
					meta.setAttribute(
						'content',
						'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no'
					);
				}, 50);
			}
		}

		// Run once on load
		window.addEventListener('load', resetZoom);

		/* 2️⃣ Disable pinch zoom AFTER reset */
		document.addEventListener('gesturestart', (e) => e.preventDefault(), {
			passive: false,
		});
		document.addEventListener('gesturechange', (e) => e.preventDefault(), {
			passive: false,
		});
		document.addEventListener('gestureend', (e) => e.preventDefault(), {
			passive: false,
		});

		/* 3️⃣ Disable double-tap zoom */
		let lastTouchEnd = 0;
		document.addEventListener(
			'touchend',
			function (e) {
				const now = Date.now();
				if (now - lastTouchEnd <= 300) {
					e.preventDefault();
				}
				lastTouchEnd = now;
			},
			{passive: false}
		);

		/* 4️⃣ Prevent two-finger drag zoom */
		document.addEventListener(
			'touchmove',
			function (e) {
				if (e.touches.length > 1) {
					e.preventDefault();
				}
			},
			{passive: false}
		);
	}

	function serializeForm(form, submitter) {
		var formData = new FormData(form, submitter);
		var serializedObject = {};

		formData.append('product_id', $(submitter).val());

		formData.forEach(function (value, key) {
			if (key.includes('[')) {
				var keys = key.split(/\[|\]/).filter(function (k) {
					return k;
				});
				var current = serializedObject;

				keys.forEach(function (subKey, index) {
					if (index === keys.length - 1) {
						if (Array.isArray(current[subKey])) {
							current[subKey].push(value);
						} else if (current[subKey]) {
							current[subKey] = [current[subKey], value];
						} else {
							current[subKey] = key.includes('[]')
								? [value]
								: value; // Key includes [] without a subkey, ie: field[].
						}
					} else {
						if (!current[subKey]) {
							current[subKey] = {};
						}
						current = current[subKey];
					}
				});
			} else {
				if (serializedObject[key]) {
					if (Array.isArray(serializedObject[key])) {
						serializedObject[key].push(value);
					} else {
						serializedObject[key] = [serializedObject[key], value];
					}
				} else {
					serializedObject[key] = value;
				}
			}
		});

		// Check if product_id exists, if not add it with the value of add-to-cart. Use variation_id for variable products.
		if (serializedObject['variation_id']) {
			serializedObject['product_id'] = serializedObject['variation_id'];
		} else if (
			!serializedObject['product_id'] &&
			serializedObject['add-to-cart']
		) {
			serializedObject['product_id'] = serializedObject['add-to-cart'];
		}

		delete serializedObject['add-to-cart']; // Need to remove this so that the form handler doesn't try to add the product to the cart again.

		return serializedObject;
	}

	$(document).on(
		'click',
		'.single_add_to_cart_button:not(.disabled)',
		function (e) {
			var $thisbutton = $(this),
				$form = $thisbutton.closest('form.cart'),
				data = serializeForm($form[0], this);

			e.preventDefault();

			$(document.body).trigger('adding_to_cart', [$thisbutton, data]);

			$.ajax({
				type: 'POST',
				url: woocommerce_params.wc_ajax_url
					.toString()
					.replace('%%endpoint%%', 'add_to_cart'),
				data: data,
				beforeSend: function (response) {
					$thisbutton.prop('disabled', true);
					$thisbutton.removeClass('added').addClass('loading');
				},
				complete: function (response) {
					$thisbutton.prop('disabled', false);
					$thisbutton.addClass('added').removeClass('loading');
				},
				success: function (response) {
					if (response.error && response.product_url) {
						window.location = response.product_url;
						return;
					}
					if($thisbutton.closest('.wish-list-page-item').length > 0) {
						$thisbutton.closest('.wish-list-page-item').find('.matat-add-to-wishlist').trigger('click');
					}
					// Fire WooCommerce hooks
					$(document.body).trigger('added_to_cart', [
						response.fragments,
						response.cart_hash,
						$thisbutton,
					]);
				},
			});

			return false;
		}
	);

	$(document).on('click', '.show-summary-wrap', function (event) {
		$('.checkout-order-mobile-review-body').slideToggle();
		$(this).toggleClass('active-slide');
	});

	jQuery(function ($) {
		let timeout;
		$('.woocommerce').on('click', '.qty-btn', function () {
			console.log('change');
			if (timeout !== undefined) {
				clearTimeout(timeout);
			}
			timeout = setTimeout(function () {
				$("[name='update_cart']").trigger('click'); // trigger cart update
			}, 1000); // 1 second delay, half a second (500) seems comfortable too
		});
	});

	jQuery(document).on('click', '.single-product-breadcrumb .bread-expand', function(e) {
		let $breadcrumb = jQuery(this);
		$breadcrumb.closest('.single-product-breadcrumb').addClass('breadcrumb-expand');
		$breadcrumb.hide();
	});

});

// Tooltip Login form
document.addEventListener('DOMContentLoaded', function () {
	const tooltip = document.querySelector('.tooltip-container');
	const body = document.body;

	// Only show and auto-hide if NOT logged in
	if (tooltip && !body.classList.contains('logged-in')) {
		setTimeout(function () {
			tooltip.classList.add('fade-out');
		}, 3000); // hide after 3 seconds
	} else if (tooltip) {
		tooltip.style.display = 'none'; // instantly hide for logged-in users
	}
});

//top Sticky

document.addEventListener('DOMContentLoaded', function () {
	const stickyElements = document.querySelectorAll('.make-sticky');
	stickyElements.forEach((el) => {
		el.style.position = 'sticky';
		el.style.top = '0';
		el.style.zIndex = '1'; // optional
	});
});

// Accordion

function initAccordion(container = document) {
	const items = container.querySelectorAll('.accordion .accordion-header');

	items.forEach((header) => {
		header.addEventListener('click', function () {
			const item = this.closest('.accordion-item');
			const isOpen = item.classList.contains('active');

			// Close all
			container
				.querySelectorAll('.accordion-item')
				.forEach((i) => i.classList.remove('active'));

			// Toggle current
			if (!isOpen) {
				item.classList.add('active');
			}
		});
	});
}

// If loaded in a popup via AJAX
document.addEventListener('DOMContentLoaded', () => {
	initAccordion(); // Initial page load

	// For AJAX popup:
	document.addEventListener('ajaxContentLoaded', function (e) {
		// Pass the container where new content is injected
		initAccordion(e.detail?.container || document);
	});
});

// cart crosssell title height

const equalizeCrossSellTitles = () => {
	const titles = document.querySelectorAll(
		'.cross-sell-slider .cross-sell-item-title'
	);
	let maxHeight = 0;

	titles.forEach((title) => {
		title.style.height = 'auto';
		const height = title.offsetHeight;
		if (height > maxHeight) maxHeight = height;
	});

	titles.forEach((title) => {
		title.style.height = maxHeight + 'px';
	});
};

const waitForCrossSellSlider = () => {
	const target = document.querySelector('.cross-sell-slider');

	if (target) {
		// Delay to allow images/layout to settle
		setTimeout(equalizeCrossSellTitles, 300);
		return;
	}

	// Watch the DOM for when cross-sell-slider appears
	const observer = new MutationObserver((mutations, obs) => {
		const slider = document.querySelector('.cross-sell-slider');
		if (slider) {
			setTimeout(equalizeCrossSellTitles, 300);
			obs.disconnect();
		}
	});

	observer.observe(document.body, { childList: true, subtree: true });
};

waitForCrossSellSlider();

// Calculate remaining space on left side for RTL product filter
const calculateRTLFilterWidth = () => {
	const filterElements = document.querySelectorAll(
		'.pandora_horizontal_filter'
	);

	filterElements.forEach((element) => {
		const rect = element.getBoundingClientRect();
		const leftPosition = rect.left;

		// Set the CSS custom property for the remaining space calculation
		element.style.setProperty(
			'--element-left-position',
			`${Math.abs(leftPosition)}px`
		);
	});
};

// Run on page load and resize
document.addEventListener('DOMContentLoaded', calculateRTLFilterWidth);
window.addEventListener('resize', calculateRTLFilterWidth);

// Also run when content is dynamically loaded (for AJAX filters)
const observer = new MutationObserver((mutations) => {
	mutations.forEach((mutation) => {
		if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
			// Check if any new filter elements were added
			const hasNewFilters = Array.from(mutation.addedNodes).some(
				(node) =>
					node.nodeType === 1 &&
					(node.classList?.contains('pandora_horizontal_filter') ||
						node.querySelector?.('.pandora_horizontal_filter'))
			);

			if (hasNewFilters) {
				setTimeout(calculateRTLFilterWidth, 100); // Small delay to ensure DOM is ready
			}
		}
	});
});

observer.observe(document.body, { childList: true, subtree: true });

// for My Account Body Class
document.addEventListener('DOMContentLoaded', function () {
	if (document.querySelector('#profile-form-container')) {
		document.body.classList.add('my-account-profile');
	}
});

// For Reset password
document.addEventListener('DOMContentLoaded', function () {
	const form = document.querySelector(
		'.woocommerce-ResetPassword.lost_reset_password'
	);
	if (!form) return;

	const inputs = form.querySelectorAll(
		'.woocommerce-Input.woocommerce-Input--text.input-text'
	);

	inputs.forEach(function (input) {
		input.addEventListener('focus', function () {
			form.classList.add('focus-input');
		});

		input.addEventListener('blur', function () {
			// check if any other input inside is still focused
			if (!form.querySelector('.woocommerce-Input:focus')) {
				form.classList.remove('focus-input');
			}
		});
	});
});

document.addEventListener('scroll', () => {
	const shopByTab = document.querySelector('.shop-by-tab-section');
	if (!shopByTab) return;

	const scrollTop = window.scrollY || document.documentElement.scrollTop;
	const windowHeight = window.innerHeight;
	const docHeight = document.documentElement.scrollHeight;

	if (scrollTop + windowHeight >= docHeight) {
		// Reached bottom
		shopByTab.classList.add('at-bottom');
	} else {
		// Not at bottom
		shopByTab.classList.remove('at-bottom');
	}
});

document.addEventListener('DOMContentLoaded', function () {
	initCustomForms();
});

// Initialize custom form elements using JCF
function initCustomForms() {
	if (typeof jcf == 'undefined') {
		return;
	}
	jcf.setOptions('Select', {
		wrapNative: false,
		wrapNativeOnMobile: false,
		fakeDropInBody: false,
	});
	jcf.replaceAll('.pickup-location-selector');
}


// Remove nbsp from price
jQuery(document).on('berocket_ajax_products_infinite_loaded', function () {
	document
		.querySelectorAll('.price, .wc-block-grid__product-price')
		.forEach((el) => {
			el.innerHTML = el.innerHTML.replace(/&nbsp;|\u00A0/g, '');
		});
});

(function () {
 document.addEventListener('DOMContentLoaded', () => {
  const DEBUG = false;
  const USE_IMPORTANT = false;
  const DURATION = 200;
  const STAGGER = 20;

  const MENU_ITEM = '.wp-block-matat-pandora-mega-menu-item-mega';

  const TARGETS = [
   '.wc-block-product-categories ul li',
   '.wp-block-heading',
   'p',
   'h1',
   'h2',
   'h3',
   'h4',
   'h5',
   'h6',
   'figure',
   '.wp-block-list li',
   '.pandora-up',
   '.primary-menu__title h3',
   '.primary-menu__title .h3',
  ].join(', ');

  /* -----------------------------------
   * Helpers
   * ----------------------------------- */
  function isPageLoading() {
   return document.body.classList.contains('page-loading');
  }

  function setStyle(el, prop, value) {
   if (USE_IMPORTANT) {
    el.style.setProperty(prop, value, 'important');
   } else {
    el.style[prop] = value;
   }
  }

  function prepareEl(el) {
   setStyle(el, 'opacity', '0');
   setStyle(el, 'transform', 'translateY(-8px)');
   setStyle(el, 'transition', 'none');
  }

  /* -----------------------------------
   * Mega menu logic
   * ----------------------------------- */
  function initMenuItem(item) {
   if (item.dataset.megaInit === '1') return;
   item.dataset.megaInit = '1';

   const dropdown = item.querySelector('.primary-menu__dropdown');
   if (!dropdown) {
    if (DEBUG) console.warn('No dropdown for', item);
    return;
   }

   let leaveTimer = null;
   let activeTimers = [];
   let navigationStarted = false;

   function clearTimers() {
    activeTimers.forEach(clearTimeout);
    activeTimers = [];
    if (leaveTimer) {
     clearTimeout(leaveTimer);
     leaveTimer = null;
    }
   }

   function resetStyles() {
    item.classList.remove('active');
    dropdown.querySelectorAll(TARGETS).forEach((el) => {
     el.style.transition = '';
     el.style.transform = '';
     el.style.opacity = '';
    });
    clearTimers();
   }

   function collectContainers() {
    const cols = dropdown.querySelectorAll('.wp-block-column');
    return cols.length ? Array.from(cols) : [dropdown];
   }

   function collectTargets(container) {
    return Array.from(container.querySelectorAll(TARGETS));
   }

   function animateIn() {
    if (isPageLoading() || navigationStarted) return;

    clearTimers();
    item.classList.add('active');

    collectContainers().forEach((container) => {
     collectTargets(container).forEach((el, index) => {
      prepareEl(el);

      const t = setTimeout(() => {
       setStyle(
        el,
        'transition',
        `opacity ${DURATION}ms ease, transform ${DURATION}ms ease`
       );
       requestAnimationFrame(() => {
        setStyle(el, 'opacity', '1');
        setStyle(el, 'transform', 'translateY(0)');
       });
      }, index * STAGGER);

      activeTimers.push(t);
     });
    });
   }

   function animateOut() {
    clearTimers();

    const containers = collectContainers();
    let maxItems = 0;

    const reversedEls = containers.map((c) => {
     const els = collectTargets(c).reverse();
     maxItems = Math.max(maxItems, els.length);
     return els;
    });

    reversedEls.forEach((els) => {
     els.forEach((el, idx) => {
      prepareEl(el);

      const t = setTimeout(() => {
       setStyle(
        el,
        'transition',
        `opacity ${DURATION}ms ease, transform ${DURATION}ms ease`
       );
       requestAnimationFrame(() => {
        setStyle(el, 'opacity', '0');
        setStyle(el, 'transform', 'translateY(-8px)');
       });
      }, idx * STAGGER);

      activeTimers.push(t);
     });
    });

    leaveTimer = setTimeout(resetStyles, DURATION + maxItems * STAGGER + 60);
   }

   /* Desktop only */
   const mql = window.matchMedia('(min-width: 1200px)');
   if (!mql.matches) return;

   item.addEventListener('pointerenter', () => {
    if (!navigationStarted && !isPageLoading()) {
     animateIn();
    }
   });

   item.addEventListener('pointerleave', () => {
    if (!navigationStarted) {
     animateOut();
    }
   });

   /* Allow normal navigation on click */
   const anchor = item.querySelector('a');
   if (anchor) {
    anchor.addEventListener('click', (e) => {
     if (
      e.metaKey ||
      e.ctrlKey ||
      e.shiftKey ||
      e.altKey ||
      e.button !== 0
     ) {
      return;
     }

     navigationStarted = true;

     e.preventDefault();
     e.stopPropagation();

     resetStyles();
     window.location.assign(anchor.href);
    });
   }

   /* Final safety cleanup */
   window.addEventListener('beforeunload', resetStyles);
  }

  function initAll() {
   document.querySelectorAll(MENU_ITEM).forEach(initMenuItem);
  }

  initAll();

  /* Support dynamically added menu items */
  const observer = new MutationObserver((mutations) => {
   if (mutations.some((m) => m.addedNodes.length)) {
    initAll();
   }
  });

  observer.observe(document.body, {
   childList: true,
   subtree: true,
  });
 });
})();


/* -----------------------------------
 * Global page-loading handler
 * ----------------------------------- */
(function () {
	document.addEventListener(
		'click',
		function (e) {
			const link = e.target.closest('a.menu-item-link');
			if (!link) return;

			if (
				e.metaKey ||
				e.ctrlKey ||
				e.shiftKey ||
				e.altKey ||
				e.button !== 0
			) {
				return;
			}

			const href = link.getAttribute('href') || '';
			if (
				href === '' ||
				href === '#' ||
				href.startsWith('javascript:') ||
				(href.startsWith('#') && href.length > 1)
			) {
				return;
			}

			try {
				const url = new URL(href, window.location.href);
				if (url.origin !== window.location.origin) return;
			} catch (err) {
				return;
			}

			document.body.classList.add('page-loading');
		},
		true
	);

	window.addEventListener('beforeunload', () => {
		document.body.classList.add('page-loading');
	});

	window.addEventListener('load', () => {
		document.body.classList.remove('page-loading');
	});

	/*
	 * Safari back/forward (bfcache) recovery.
	 * When a page is restored from the back/forward cache, Safari fires
	 * `pageshow` with `event.persisted === true` and does NOT fire `load`.
	 * That leaves the `page-loading` state from `beforeunload` stuck on the
	 * restored page, and the WooCommerce cart fragments / mini-cart reflect a
	 * stale (pre-navigation) state. Clear the overlay state and refresh the
	 * cart fragments so the restored page is usable and current.
	 */
	window.addEventListener('pageshow', (e) => {
		if (!e.persisted) return;
		document.body.classList.remove('page-loading');
		if (window.jQuery) {
			jQuery(document.body).trigger('wc_fragment_refresh');
		}
	});
})();


/* -----------------------------------
 * Login form gender toggle
 * ----------------------------------- */
(function () {
	jQuery(".drop-down .opener").click(function(){
		jQuery(".drop-down .radio-button").stop(true, false, true).slideToggle();
	});
})();

